import React, { useState, useEffect } from 'react'
// import { useErrorBoundary } from 'react-error-boundary'


export const DataContext = React.createContext()



export function FetchJson({ children } = {}) {
  const [data, setData] = useState(null)
//   const { showBoundary } = useErrorBoundary()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    try {

     
      // Fetch data from the JSON file
      fetch(process.env.PUBLIC_URL + '/data/gameData.json')
        .then((response) => response.json())
        .then((data) => {
          setData(data)
          setLoading(false)
        })
        .catch((error) => {
          console.error('Error loading json:', error)
          setLoading(false)
        })
    } catch (err) {
    //   showBoundary(err)
    }
  }, [])

  // return data

  return (
    <DataContext.Provider value={{ data, loading }}>
      {children}
    </DataContext.Provider>
  )
}
